<template>
  <div class="event-preview-frame" :class="{
    pre:
      !form.EventDetails.type ||
      (form.EventDetails.type && !event.has_draft && !event.has_events),
    [`${event.current_locale}-class`]:
      event.current_locale === 'en' ? 'en-class' : 'he-class',
  }">
    <main v-if="form.EventDetails.type && (event.has_draft || event.has_events)"
      class="flex flex-col  overflow-hidden ">
      <!----
    w-full h-full relative
    <div class="w-[100vw] h-[100vh] scale-x-[0.525] scale-y-[0.68] origin-top-left absolute top-0 left-0 shadow-md overflow-y-auto">
    -->
      <div :class="{
        'h-[280px]': form.EventDetails.type === 'contact_me' || form.EventDetails.type === 'guide_download',
        'h-[calc(48vh-192*0.48px)]': form.EventDetails.type !== 'contact_me' && form.EventDetails.type !== 'guide_download',
        'relative': true,
        'z-10': true,
        'flex': true,
        'flex-col': true,
        'items-start': true,
        'justify-start': true,
        'self-end': true,
        'max-w-full': true,
        'font-bold': true,
        'text-white': true,
        'w-full': true,
        'max-w-[1184px]': true,
        'sm:pt-8': true
      }">
        <div
          class="absolute inset-0 sm:bg-top bg-center bg-cover bg-opacity-30 sm:bg-opacity-100 sm:bg-cover bg-no-repeate"
          :class="(form.EventDetails.type !== 'contact_me' && form.EventDetails.type !== 'guide_download') ? 'sm:h-[calc(53vh-192*0.53px)] ' : 'h-[370px]'" :style="{
            backgroundImage: `url(${previewCoverSrc})`,

          }"></div>
        <div class="absolute  inset-0  -z-10 sm:bg-top bg-center bg-cover bg-no-repeat"
          style="filter: brightness(1.5) contrast(0.8) saturate(1.2);"
          :class="(form.EventDetails.type !== 'contact_me' && form.EventDetails.type !== 'guide_download') ? 'sm:h-[calc(53vh-192*0.53px)] ' : 'h-[370px]'" :style="{
            backgroundImage: `url(${previewCoverSrc})`,
          }"></div>
        <!--- filter: !isDesctop ? 'blur(10px)' : 'none'-->
        <div class="absolute inset-  "
          :class="(form.EventDetails.type !== 'contact_me' && form.EventDetails.type !== 'guide_download') ? 'sm:h-[calc(53vh-192*0.53px)] ' : 'h-[370px]'"></div>
        <!----<div class="relative w-full "
  v-if="!isDesctop">
      <img
        loading="lazy"
        :src="previewCoverSrc"
        class="object-contain w-full"
      />
      <div class="absolute inset-0 bg-black opacity-30"></div>
      </div>-->
        <div :class="(form.EventDetails.type != 'contact_me' && form.EventDetails.type != 'guide_download') ? 'items-center h-full justify-center' : 'items-start'"
          class="relative z-10 flex flex-col self-end max-w-full font-bold text-white w-full max-w-[1184px]">
          <img loading="lazy" v-if="form.EventDetails.type == 'contact_me' || form.EventDetails.type == 'guide_download'" :src="previewLogo"
            class="object-contain max-w-full aspect-square rounded-full w-24 mr-24 sm:mt-0 -mt-12 " />

          <div
            v-show="form.EventDetails.name_position !== 'none' && form.EventDetails.name_position !== 'bottom'"
            :class="(form.EventDetails.type != 'contact_me' && form.EventDetails.type != 'guide_download') ? 'w-full flex justify-center sm:text-4xl px-auto' :
              'flex flex-col justify-center items-center self-start sm:pr-[16.5%] pr-[5%] sm:mt-2 max-w-full sm:text-2xl tracking-widest leading-10 text-right w-[940px]'">

            <div class="w-full max-md:pl-5" style="text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8);" :class="[
              (form.EventDetails.type != 'contact_me' && form.EventDetails.type != 'guide_download') ?
                `py-4 px-8 text-${customColorClass}  rounded-lg text-${form.EventDetails.name_position}` :
                `text-${customColorClass}`
            ]">
              <span v-if="form.EventDetails.type == 'contact_me' || form.EventDetails.type == 'guide_download'" class="sm:text-3xl text-2xl">{{ withSpeakerName }}
                <br></span>
              {{ detailsEventName }}
            </div>
          </div>
          <button v-if="form.EventDetails.type == 'contact_me'"
            class="
        transition-colors duration-300 text-white  rounded-[70px] max-md:px-5  border-solid  py-5  text-xl text-center
       flex justify-center mb-6 sm:mb-0 items-center px-24 sm:mt-2 sm:mr-[16.5%] mr-[5%]  border-violet-800 bg-violet-800  hover:bg-violet-500 border"
            aria-label="יצירת קשר">
            <span class="self-stretch my-auto"> {{ $trans("event.fields.preview_submit_text") }}</span>
          </button>
          <button v-if="form.EventDetails.type == 'guide_download'"
            class="
        transition-colors duration-300 text-white  rounded-[70px] max-md:px-5  border-solid  py-5  text-xl text-center
       flex justify-center mb-6 sm:mb-0 items-center px-24 sm:mt-2 sm:mr-[16.5%] mr-[5%]  border-violet-800 bg-violet-800  hover:bg-violet-500 border"
            aria-label="הורדת המדריך">
            <span class="self-stretch my-auto"> {{ $trans("event.create.submit_guide_download") }}</span>
          </button>
        </div>
      </div>
      <div v-if="form.EventDetails.type !== 'contact_me' && form.EventDetails.type !== 'guide_download'" :style="{
        ...infoBarBg,
        color: eventNameColor || '#b972ff',
        backgroundColor: form.EventDetails.background_color || '#b972ff'
      }" dir="rtl" class="py-3 hidden md:block z-[20]">
        <!--- <div
  v-if="form.EventDetails.name_position == 'bottom'"
  dir="rtl"
  :style="{ color: eventNameColor || '#b972ff', backgroundColor: form.EventDetails.background_color || '#b972ff' }"
  class="w-full max-md:pl-5 py-4 px-auto backdrop-blur-sm bg-black/20 rounded-lg text-center"
>
  {{ detailsEventName }}
</div>-->
        <div class="container mx-auto flex justify-center items-center ">
          <div class="flex flex-row items-center space-x-3" v-if="showEventDate">
            <div v-html="$icon('calendar')" alt="Calendar" class="w-6 h-6 mx-2 mb-1"></div>
            <div class="bar-text" :style="customEventColor" v-if="eventDateText" v-html="eventDateText"></div>
          </div>
          <div class="flex flex-row items-center space-x-3" v-if="showEventTime">
            <div class="w-6 h-6 mx-2 mb-1" :class="[customColorClass]" v-html="$icon('clock')"></div>
            <div class="bar-text" :style="customEventColor" v-if="eventTimeText.length" v-html="eventTimeText"></div>
          </div>
          <div class="flex flex-row items-center space-x-3" v-if="showEventLocation">
            <div class="w-6 h-6 mb-1 mx-2" v-html="$icon('location-white')"></div>
            <div class="bar-text" :style="customEventColor" v-if="eventLocationText" v-html="eventLocationText"></div>

          </div>
          <div class="flex flex-row items-center space-x-3" v-if="form.EventDetails.payment_required !== 2">
            <div v-html="$icon('payments')" class="w-6 h-6 mb-1 mx-2 text-white"></div>
            <div class="bar-text" :style="customEventColor">{{ paymentText }}</div>
          </div>
        </div>
      </div>

      <div class="relative  bg-cover bg-center"
        :class="(form.EventDetails.type == 'contact_me' || form.EventDetails.type == 'guide_download') ? 'pt-20 pb-10 ' : 'py-0'">

        <div :style="{
          backgroundImage: `url(${previewCoverSrc})`
        }" style="opacity:0.1; filter: brightness(1.5) contrast(0.8) saturate(1.2);"
          class="absolute inset-0 bg-cover bg-no-repeat bg-center bg-fixed  blur-sm opacity-50 "
          :class="(form.EventDetails.type != 'contact_me' && form.EventDetails.type != 'guide_download') ? '' : 'scale-[1.2]'"></div>
        <div
          class="relative z-10 flex justify-center items-start self-center   shadow-[0px_4px_4px_rgba(0,0,0,0.25)] sm:w-[66%] mx-auto bg-white/90 backdrop-blur-sm"
          :class="(form.EventDetails.type != 'contact_me' && form.EventDetails.type != 'guide_download') ? 'mt-0' : '-mt-40'">
          <div
            class="flex flex-col flex-1 shrink pt-2  w-full  min-w-[240px] max-md:pt-10 max-md:px-5 max-md:max-w-full">
            <div class="  bg-white  text-black max-md:max-w-full space-y-6 ">
              <!-- כותרת למטה - מוצגת מתחת לסטריפ/תמונה מעל הטקסט, ככותרת ראשית בולטת -->
              <div
                v-if="form.EventDetails.name_position === 'bottom' && form.EventDetails.name_position !== 'none' && form.EventDetails.type !== 'contact_me' && form.EventDetails.type !== 'guide_download'"
                class="w-full"
                :style="{ borderBottom: `3px solid ${form.EventDetails.background_color || '#b972ff'}` }">
                <div
                  dir="rtl"
                  class="w-full text-center font-extrabold text-2xl sm:text-4xl py-5 px-6 tracking-wide leading-tight"
                  :style="{ color: form.EventDetails.background_color || '#b972ff' }">
                  {{ detailsEventName }}
                </div>
              </div>
              <div class="px-4">
                <div
                  v-if="form.EventDetails.spintowin_enabled && form.EventDetails.spintowin_token && form.EventDetails.spintowin_position === 'top1'"
                  class="spintowin-iframe-wrapper w-full my-4">
                  <iframe :src="`https://spintowinweb.azurewebsites.net/?g=${form.EventDetails.spintowin_token}`"
                    class="w-full h-[600px] border-none" allow="geolocation"></iframe>
                </div>
                <div class="py-4" v-if="
                  form.EventDetails.description &&
                  form.EventDetails.description.length
                " v-html="form.EventDetails.description"></div>

                <img v-if="form.EventDetails.show_middle_image" :src="middleImage" class="object-contain w-full py-2" />
                <div
                  v-if="form.EventDetails.spintowin_enabled && form.EventDetails.spintowin_token && form.EventDetails.spintowin_position === 'top2'"
                  class="spintowin-iframe-wrapper w-full my-4">
                  <iframe :src="`https://spintowinweb.azurewebsites.net/?g=${form.EventDetails.spintowin_token}`"
                    class="w-full h-[600px] border-none" allow="geolocation"></iframe>
                </div>
                <div v-if="
                  form.EventDetails.extra_description &&
                  form.EventDetails.extra_description.length
                " v-html="form.EventDetails.extra_description"></div>
              </div>
              <img v-if="form.EventDetails.show_bottom_image" :src="bottomImage" class="styled-image" />
              <div v-if="
                form.EventDetails.second_extra_description &&
                form.EventDetails.second_extra_description.length
              " v-html="form.EventDetails.second_extra_description"></div>
              <div
                v-if="form.EventDetails.spintowin_enabled && form.EventDetails.spintowin_token && form.EventDetails.spintowin_position === 'bottom'"
                class="spintowin-iframe-wrapper w-full my-4 px-4">
                <iframe :src="`https://spintowinweb.azurewebsites.net/?g=${form.EventDetails.spintowin_token}`"
                  class="w-full h-[600px] border-none" allow="geolocation"></iframe>
              </div>
            </div>
            <div v-if="form.EventDetails.has_lecturer" dir="rtl"
              class="flex flex-wrap flex-row  items-center px-16 py-9 w-full bg-slate-200 min-h-[247px] shadow-[0px_4px_4px_rgba(0,0,0,0.25)] max-md:px-5">
              <div
                class="flex  flex-col justify-center items-start self-stretch pl-8 my-auto max-w-[150px] min-h-[129px] min-w-[150px] w-[150px]">
                <img loading="lazy" :src="lecturerImage" alt={therapist.name}
                  class="object-contain w-full aspect-square min-w-[120px] rounded-[800px]" />
              </div>
              <div
                class="flex flex-col self-stretch my-auto text-right min-h-[129px] w-[calc(100%-150px)] max-md:max-w-full">
                <h3 class="max-w-full text-2xl font-bold leading-tight text-black  w-[650px] max-md:pl-5">
                  {{ lecturerName }}
                </h3>
                <p class="mt-2 max-w-full text-lg leading-8 text-zinc-600  max-md:max-w-full">
                  {{ lecturerDesc }}
                </p>
              </div>
            </div>
            <div dir="rtl"
              class="flex flex-wrap flex-row  items-center px-16 py-9 w-full bg-slate-200 min-h-[247px] shadow-[0px_4px_4px_rgba(0,0,0,0.25)] max-md:px-5"
              v-if="!form.EventDetails.has_lecturer">
              <div
                class="flex  flex-col justify-center items-start self-stretch pl-8 my-auto max-w-[150px] min-h-[129px] min-w-[150px] w-[150px]">

                <img class="object-contain w-full aspect-square min-w-[120px] rounded-[800px]"
                  :src="form.BrandingDetails.player_image" />
              </div>
              <div
                class="flex flex-col self-stretch my-auto text-right min-h-[129px] w-[calc(100%-150px)] max-md:max-w-full">
                <h3 class="max-w-full text-2xl font-bold leading-tight text-black  w-[650px] max-md:pl-5"
                  v-if="form.BrandingDetails.player_name">
                  {{ form.BrandingDetails.player_name }}
                </h3>
                <p class="mt-2 max-w-full text-lg leading-8 text-zinc-600  max-md:max-w-full"
                  v-html="form.BrandingDetails.player_description" v-if="form.BrandingDetails.player_description"></p>
              </div>
            </div>

          </div>
        </div>
      </div>
      <!-- <div class="speaker-info">
                <div v-if="!isUserDetails">
                  <div class="speaker-name" v-if="showLecturerName">
                    {{ $trans("event.create.lectureName") }}

                  </div>
                  <div class="speaker-desc" v-if="showLecturerDesc">
                    {{ $trans("event.create.lectureDes") }}

                  </div>
                </div>
                <div v-else>
                  <div class="speaker-name" v-if="showLecturerName">
                    {{ lecturerName }}
                  </div>
                  <div
                    class="speaker-desc"
                    style="overflow-wrap: break-word"
                    v-html="lecturerDesc"
                    v-if="showLecturerDesc"
                  ></div>
                </div>
              </div> -->



      <!-- <div class="preview-body-bg" :style="previewBodyBg"></div> -->
      <div dir="rtl"
        class="relative z-10 flex flex-col items-center px-16 py-4 w-full bg-red-100 shadow-[0px_4px_4px_rgba(0,0,0,0.25)] max-md:px-5 max-md:max-w-full">
        <div class="max-w-full w-[1174px]">
          <div dir="ltr" class="flex gap-5 max-md:flex-col justify-center items-center align-middle"
            :class="(form.EventDetails.type !== 'contact_me' && form.EventDetails.type !== 'guide_download') ? 'justify-center items-center align-middle' : 'flex-row'">
            <contactForm :typeOf="form.EventDetails.type" :submit_btn_text="$trans('event.fields.footer_send_btn')" />
            <contactInfo v-if="form.EventDetails.type == 'contact_me'" :head="$trans('event.create.contact_us')"
              :phone="form.BrandingDetails.player_business_phone" :email="form.BrandingDetails.player_email"
              :logo="previewLogo"
              :socialLinks="[{ id: 1, url: 'https://www.facebook.com/', icon: 'facebookIcon' }, { id: 3, url: 'https://www.instagram.com/', icon: 'instagramIcon' }]" />
          </div>
        </div>
      </div>
      <!----

      >-->
      <!-- <div class="preview-title">{{ previewTitle }}</div> -->
      <!----

              <p class="info-social">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                  width="24"
                >
                  <path d="M0 0h24v24H0z" fill="none" />
                  <path
                    d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
                    fill="#BF6965"
                  /></svg><span class="p-info">{{
                  form.BrandingDetails.player_email
                }}</span>
              </p>
              {{ getSocialMediaLinks }}
              <div
                class="social-media-icon"
                style="border-top: 1px solid #bf6965; padding: 10px"
              >
                <a :href="getInstaLink" target="_blank">
                  <img src="../../../../images/icons/instagram.svg" />
                </a>-->
      <!-- <a href="https://www.example.com" target="_blank">Visit Example.com</a> -->
      <!-- {{ getFbLink }} -->
      <!---     <a :href="getFbLink" target="_blank">
                  <img src="../../../../images/icons/facebookTwo.svg" />
                </a>
              </div>
            </div>
          </div>
          <div class="preview-fields">
            <div class="main-fields">
              <div class="preview-submit">
                <button type="button">
                  {{ $trans("event.fields.footer_send_btn") }}
                </button>
              </div>
              <div class="additional-fields">
                <div class="field-item" v-if="eventFields.includes(1)">
                  <div class="">
                    <div class="field-label">
                      <app-input
                        class="field-input preview-name-field"
                        :type="text"
                        :placeholder="$trans('event.create.que')"
                      >
                      </app-input>
                    </div>
                  </div>
                </div>

                <div class="field-item" v-if="eventFields.includes(11)">
                  <div class="">
                    <div class="field-label">
                      <app-input
                        class="field-input preview-name-field"
                        :type="text"
                        :placeholder="$trans('event.create.occupation')"
                      >
                      </app-input>-->
      <!-- {{ $trans("event.fields.field_11") }} -->
      <!----   </div>
                  </div>
                </div>

                <div class="field-item" v-if="eventFields.includes(9)">
                  <div class="field-item-inner">
                    <div class="field-label">
                      <app-input
                        class="field-input preview-name-field"
                        :type="text"
                        :placeholder="$trans('event.create.phone')"
                      >
                      </app-input>-->
      <!-- {{ $trans("event.fields.field_9") }} -->
      <!----  </div>
                  </div>
                </div>
              </div>
              <div class="field-item preview-field-item">
                <div class="field-item-inner">
                  <app-input
                    class="field-input preview-name-field"
                    :direction="inputDirection"
                    :type="text"
                    :placeholder="$trans('event.fields.field_email')"
                  >
                  </app-input>
                  <!-- <div class="field-label">
                                        {{ $trans("event.fields.field_email") }}-->
      <!---- </div>
                </div>
              </div>
              <div class="field-item preview-field-item">
                <div class="field-item-inner">
                  <app-input
                    class="field-input preview-name-field"
                    :type="text"
                    :placeholder="$trans('event.fields.field_last_name')"
                  >
                  </app-input>
                  <!-- <div class="field-label">
                                        {{
                                            $trans(
                                                "event.fields.field_last_name"
                                            )
                                        }}
                                    </div> -->
      <!----   </div>
              </div>
              <div class="field-item preview-field-item">
                <div class="field-item-inner">-->
      <!-- <input type="text" class="field-input preview-name-field" name="first_name" placeholder="event.fields.field_first_name"/> -->
      <!----  <app-input
                    class="field-input preview-name-field"
                    :type="text"
                    :placeholder="$trans('event.fields.field_first_name')"
                  >
                  </app-input>
                  <!-- <div class="field-label">
                                        {{
                                            $trans(
                                                "event.fields.field_first_name"
                                            )
                                        }}
                                    </div> -->
      <!----  </div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <p class="footer-text">
            © 2024, {{ $trans("event.fields.footer_bottom_text") }}
          </p>
        </div>
      </section>
    </main>
    <main v-else class="event-pre-preview">
      <div class="pre-title">{{ $trans("event.preview.welcome") }}</div>
      <div class="pre-text">{{ preText }}</div>
      <button class="pre-btn"></button>-->
    </main>
  </div>
</template>

<script>
import contactForm from './contactForm.vue';
import contactInfo from './contactInfo.vue';
import { useDeviceView } from '../../../isDesctop.js';
const { isDesktop, userPreference, setPreferredView } = useDeviceView()

import queryString from "../../../plugins/query-string-object";
import GoogleTranslateSelect from "@google-translate-select/vue3";

function hexToRGB(hex, alpha) {
  const r = parseInt(hex.slice(1, 3), 16),
    g = parseInt(hex.slice(3, 5), 16),
    b = parseInt(hex.slice(5, 7), 16);

  if (alpha) {
    return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
  } else {
    return "rgb(" + r + ", " + g + ", " + b + ")";
  }
}

import moment from "moment";
import { nextTick } from "vue";

export default {
  components: {
    contactForm,
    contactInfo
  },
  data() {
    return {
      steps: window.app.steps,
      form: window.app.form,
      event: window.app.event,
      croppingImage: false,
      currentStep: 0,
      selectedLocale: "",
      availableLanguages: ["en", "he"],
      isDescription: false,
      isUserDetails: false,
    };
  },
  mounted() {
    console.log("eventpreview", this.form.EventDetails.type);
    // console.log("showLecturerDesc ", this.showLecturerDesc);
    console.log("eventpreviewww", this.event);
    // console.log("currentLocale", this.event.current_locale);
    // console.log("window.app.form", window.app.form);
    window.eventBus.on("stepChange", () => {
      this.currentStep = this.hashStep();
    });

    window.eventBus.on("croppingImage", (image) => {
      this.croppingImage = image;
    });

    window.eventBus.on("sideBySide", (el) => {
      console.log("sideBySidesideBySide", el);
      const previewFrame = $(".event-preview-frame");
      // const mainTop = previewFrame.offset().top;
      // const scrollTop = previewFrame.scrollTop();

      // let scrollTo;

      if (el === "event_type") {
        if ($(".preview-title")[0]) {
          $(".preview-title")[0].getBoundingClientRect();
        }
        // scrollTo = scrollTop +
        //  $(".preview-title")[0].getBoundingClientRect();
        //  .y * 0.6 - mainTop;
      } else if (el === "cover_image") {
        if (!$(".preview-cover-image").length) {
          return;
        }
        // scrollTo =
        // scrollTop +
        $(".preview-cover-image")[0].getBoundingClientRect();
      } else if (el === "event_name") {
        if (this.isPixabay) {
          // scrollTo =
          // scrollTop +
          $(".preview-cover-image")[0].getBoundingClientRect();
        } else {
          // scrollTo =
          // scrollTop +
          $(".preview-event-details")[0].getBoundingClientRect();
        }
      } else if (el === "info_bar") {
        // scrollTo =
        // scrollTop +
        $(".preview-info-bar")[0].getBoundingClientRect();
      } else if (el === "description") {
        this.isDescription = true;
        // scrollTo =
        // scrollTop +
        $(".preview-blocks")[0].getBoundingClientRect();
      } else if (el === "lecturer") {
        this.isUserDetails = true;
        if (this.form.EventDetails.has_lecturer) {
          const speakerElement = $(".preview-speaker")[0];
          if (speakerElement) {
            speakerElement.getBoundingClientRect();
          }
        }
      } else if (el === "fields") {
        // scrollTo =
        // scrollTop +
        $(".preview-fields")[0].getBoundingClientRect();
      } else if (el === "spintowin") {
        const swElement = $(".spintowin-iframe-wrapper")[0];
        if (swElement) {
          swElement.getBoundingClientRect();
        }
      }
      // .y * 0.6 -
      // mainTop

      if (previewFrame.data("animating")) {
        return;
      }

      previewFrame.data("animating", 1);
      previewFrame.stop();
      // previewFrame.animate(
      //   {
      //     scrollTop: `${scrollTo}px`,
      //   },
      //   "slow",
      //   function () {
      //     $(this).removeData("animating");
      //   }
      // );
    });

    window.addEventListener("hashchange", () => {
      this.currentStep = this.hashStep();
    });

    this.currentStep = this.hashStep();
  },
  methods: {
    switchLanguage() {
      this.$emit("language-changed", this.selectedLocale);
    },

    hashStep() {
      let hash = window.location.hash.substring(2);
      let parameters = hash.split("/");
      let query = hash.split("?");
      query = query.pop();
      hash = parameters.shift();

      if (query) {
        query = queryString.parse(query);

        if (query.step) {
          return parseInt(query.step);
        }
      }
      return 0;
    },
  },

  computed: {
    // getFbLink() {
    //   const fbLink = this.form.BrandingDetails.player_links.filter((link) => {
    //     return link.type == "facebook"
    //   })
    //   console.log("fbLink", fbLink);
    //   return fbLink[0];
    // },

    // getInstaLink() {
    //   const instaLink = this.form.BrandingDetails.player_links.filter((link) => {
    //     return link.type == "instagram"
    //   })
    //   console.log("fbLink", instaLink);
    //   return instaLink[0];
    // },
    paymentText() {
      return this.form.EventDetails.payment_required === 1
        ? this.$trans("event.create.yes_payment_lebel")
        : this.$trans("event.create.no_payment");
    },
    // paymentText is not read when payment_required === 2, since the payment bar is hidden entirely
    getInstaLink() {
      const instaLink = this.form.BrandingDetails.player_links.filter(
        (link) => link.type === "instagram"
      );
      // console.log("fbLink", instaLink);
      // return instaLink.length > 0? instaLink[0].url : ''; // Assuming each link has a 'url' property
      return instaLink.length > 0 ? instaLink[0]?.url.replace(/^#/, "") : ""; // Assuming each link has a 'url' property
    },
    getFbLink() {
      const fbLink = this.form.BrandingDetails.player_links.filter(
        (link) => link.type === "facebook"
      );
      // console.log("fbLink", fbLink);
      // window.open(fbLink[0].url, '_blank')
      // return fbLink.length > 0? fbLink[0].url : ''; // Assuming each link has a 'url' property
      return fbLink.length > 0 ? fbLink[0]?.url.replace(/^#/, "") : ""; // Assuming each link has a 'url' property
    },

    inputDirection() {
      // Check if the current locale is Urdu or another RTL language
      return this.$i18n.locale.startsWith("he") ? "rtl" : "ltr";
    },
    availableLocales() {
      return ["en", "he"]; // Add more locales as needed
    },
    eventFields() {
      console.log("formmmmmm", this.form);
      return this.form.EventDetails.event_fields;
    },
    showLecturerImage() {
      return (
        //   this.notFilledLecturer ||
        (this.filledLecturer && this.form.EventDetails.lecturer_image)
      );
    },
    showLecturerName() {
      return (
        //   this.notFilledLecturer ||
        (this.filledLecturer && this.form.EventDetails.lecturer_name)
      );
    },
    showLecturerDesc() {
      return (
        //  this.notFilledLecturer ||
        (this.form.EventDetails.lecturer_desc)
      );
    },
    /*  notFilledLecturer() {
        return (
          !this.form.EventDetails.lecturer_name &&
          !this.form.EventDetails.lecturer_desc
        );
      },*/
    /* filledLecturer() {
       return (
         this.form.EventDetails.lecturer_name ||
         this.form.EventDetails.lecturer_desc
       );
     },*/
    lecturerName() {
      const isTadType = this.form.EventDetails.type === "contact_me" || this.form.EventDetails.type === "guide_download";
      return this.form.EventDetails.lecturer_name || this.$trans(isTadType ? "event.create.lecturer_tad_name" : "event.create.lecturer_here");
    },
    lecturerDesc() {
      const isTadType = this.form.EventDetails.type === "contact_me" || this.form.EventDetails.type === "guide_download";
      return this.form.EventDetails.lecturer_desc || this.$trans(isTadType ? "event.create.lecturer_tad_desc_here" : "event.create.lecturer_desc_here")
    },
    middleImage() {
      return this.form.EventDetails.middle_image;
    },
    bottomImage() {
      return this.form.EventDetails.bottom_image;
    },
    lecturerImage() {
      const image = this.form.EventDetails.lecturer_image || this.event.user;
      if (image instanceof File) {
        return URL.createObjectURL(image);
      }
      return image;
    },

    preText() {
      return this.$trans(`event.preview.pre_text_${this.currentStep}`);
    },
    previewLogo() {
      return this.form.BrandingDetails.player_image;
    },
    namePosition() {
      return this.form.EventDetails.name_position;
    },
    eventType() {
      if (this.form.EventDetails.pixabay_image) {
        return "pixabay";
      }

      return "custom";
    },
    isPixabay() {
      return this.eventType === "pixabay";
    },
    isCustom() {
      return this.eventType === "custom";
    },
    previewTitle() {
      if (!this.form.EventDetails.type) {
        return this.$trans("event.create.register");
      }

      return this.$trans(`event.create.title_${this.form.EventDetails.type}`);
    },
    previewSubmitText() {
      if (!this.form.EventDetails.type) {
        return this.$trans("event.create.register");
      }

      return this.$trans(`event.create.submit_${this.form.EventDetails.type}`);
    },
    noBarInformation() {
      return (
        !this.eventTimeText && !this.eventDateText && !this.eventLocationText
      );
    },
    showInfoBar() {
      return (
        (!this.eventTimeText &&
          !this.eventDateText &&
          !this.eventLocationText) ||
        this.eventTimeText ||
        this.eventDateText ||
        this.eventLocationText
      );
    },
    showEventDate() {
      return (
        this.noBarInformation || (!this.noBarInformation && this.eventDateText)
      );
    },
    showEventTime() {
      return (
        this.noBarInformation ||
        (!this.noBarInformation && this.eventTimeText.length)
      );
    },
    showEventLocation() {
      return (
        this.noBarInformation ||
        (!this.noBarInformation && this.eventLocationText)
      );
    },
    eventTimeText() {
      const startTime = this.form.EventDetails.start_time;
      const endTime = this.form.EventDetails.end_time;

      let time = "";

      if (startTime && startTime.length) {
        time = startTime;
      }
      if (endTime && endTime.length) {
        if (startTime && startTime.length) {
          time += ` - ${endTime}`;
        } else {
          time += `${endTime}`;
        }
      }

      return time;
    },
    eventLocationText() {
      const address = this.form.EventDetails.location;

      return address && this.form.EventDetails.location_type === "offline"
        ? address
        : this.form.EventDetails.location_type === "online"
          ? this.$trans("event.create.online_event")
          : false;
    },
    eventDateText() {
      const startDate = this.form.EventDetails.start_date;
      const endDate = this.form.EventDetails.end_date;

      let text = false;

      if (startDate && startDate.length) {
        text = moment(new Date(startDate), "LLLL", "he").format("MMMM DD");
      }
      if (endDate && endDate.length) {
        text += ` - ${moment(new Date(endDate), "LLLL", "he").format(
          "MMMM DD"
        )}`;
      }

      return text;
    },
    withSpeakerName() {
      return this.form.EventDetails.lecturer_name || this.form.BrandingDetails.player_name
    },
    customColorClass() {
      return this.form.EventDetails.text_color === "#ffffff"
        ? "white"
        : "black";
    },
    customEventColor() {
      return {
        color: this.form.EventDetails.text_color,
      };
    },
    previewCover() {
      const image = this.form.EventDetails.cover_image
        ? this.form.EventDetails.cover_image
        : this.form.EventDetails.pixabay_image
          ? this.form.EventDetails.pixabay_image
          : false;

      if (!image) {
        return {};
      }

      return {
        backgroundImage: `url(${image})`,
      };
    },
    previewCoverSrc() {
      if (this.croppingImage) {
        return this.croppingImage;
      }

      const image = this.form.EventDetails.cover_image
        ? this.form.EventDetails.cover_image
        : this.form.EventDetails.pixabay_image
          ? this.form.EventDetails.pixabay_image
          : this.event.no_cover;

      return image;
    },
    previewBodyBg() {
      return this.previewCover;
    },
    previewCoverBgColor() {
      let gradient = hexToRGB(this.backgroundColor, 0.49);
      // let gradient = LightenDarkenColor(this.backgroundColor, 50);

      return {
        backgroundImage: `linear-gradient(180deg, ${gradient} 0%, rgba(255,255,255,0.49) 100%)`,
        // background: `linear-gradient(180deg, ${gradient} 0%, rgba(255,255,255,0.49) 100%)`
      };
    },
    speakerBgColor() {
      return {
        backgroundColor: "#FBF3F4",
      };
    },
    infoBarBg() {
      return {
        background: this.backgroundColor,
      };
    },
    textColor() {
      return {
        color: this.backgroundColor,
      };
    },
    backgroundColor() {
      const defaultBg = "#aa93cf";

      return this.form.EventDetails.background_color
        ? this.form.EventDetails.background_color
        : defaultBg;
    },
    detailsEventName() {
      return this.form.EventDetails.event_name
        ? this.form.EventDetails.event_name
        : this.$trans("event.create.title");
    },
    detailsSpeakerName() {
      return this.withSpeakerName
        ? this.withSpeakerName
        : this.$trans("event.create.lecturer_name");
    },
  },
};
</script>



<style scoped lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Open+Sans+Hebrew:wght@400;700&display=swap');

* {
  font-family: 'Open Sans Hebrew', sans-serif;
}

.text-left {
  text-align: left;
}

main.event-preview .preview-fields .main-fields .field-item {
  width: 100%;
}

main.event-preview .preview-submit button {
  background-color: #bf6965;
}

main.event-preview .preview-fields .main-fields .field-item .field-item-inner .field-label {
  color: #bf6965;
}

main.event-preview .preview-fields .main-fields .field-item .field-item-inner {
  border: none;
}

.images-description {
  display: flex;
  gap: 20px;
  flex-direction: column;
}

main.event-preview .preview-title {
  color: #bf6965;
}

body.event-creation .app-input input {
  border-radius: 12px;
  margin-top: 20px;
  border-bottom: 1px solid #bf6965;
}

:deep(.preview-name-field .app-input-wrap input) {
  padding: 30px;
  border-radius: 20px;
  border: solid 1px #bf6965;
  letter-spacing: 0.64px;
  font-size: 15px;
}

.preview-fields-two {
  margin-top: 75px;
  margin-bottom: 93px;
}

.social-media-icon img {
  margin-left: 2px;
  fill: #bf6965;
}

.field-item-inner .field-label {
  color: #bf6965;
  margin-bottom: 5px;
}

.en-class .preview-speaker {
  justify-content: start;
  gap: 20px;
}

.he-class .preview-speaker {
  gap: 20px;
}

.en-class .preview-speaker .speaker-info {
  text-align: left !important;
}

.en-class main.event-preview .preview-header .preview-logo {
  left: 30px;
  right: unset;
}

.en-class .preview-fields-two {
  direction: ltr;
}

.en-class {
  :deep(.preview-name-field .app-input-wrap input) {
    direction: ltr;
  }
}

.en-class .social-media-icon img {
  margin-right: 10px;
  margin-left: 0;
}

.he-class .social-media-icon img {
  margin-right: 0px;
  margin-left: 10px;
}

.info-social {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px !important;
}

.p-info {
  font-size: 25px;
}

.footer-text {
  font-size: 25px;
}

.he-class .preview-blocks {
  word-wrap: break-word;
}

.en-class .preview-blocks {
  word-wrap: break-word;
}

.he-class .preview-blocks-two {
  word-wrap: break-word;
}

.en-class .preview-blocks-two {
  word-wrap: break-word;
}

.en-class .preview-image-block-section {
  flex-direction: row-reverse;
}

.en-class .second-des {
  flex-direction: row-reverse;
}

.he-class .second-des {
  flex-direction: row-reverse;
}

.en-class {
  .preview-middle-image {
    img {
      float: right;
      padding-left: 12px;
    }
  }
}

.he-class {
  .preview-middle-image {
    img {
      float: left;
      padding-right: 12px;
    }
  }
}

.flex-row {
  display: flex;
  align-items: center;
}

.bar-text {
  display: flex;
  align-items: center;
}
</style>
